import { createBrowserHistory } from 'history';
import { invert } from 'lodash';

export const routesNames = {
  main: '/',
  auth: '/auth',
  notFound: '*',
  logIn: '/log-in',
  notice: '/notice',
  init: '/organizer',
  profile: '/profile',
  verifyCode: '/verify-code',
  details: '/opportunity-details',
  resetPassword: '/reset-password',
  createPassword: '/create-password',
  editOpportunity: '/opportunity-edit',
  createOpportunity: '/opportunity-create',
};

export const lackData = {
  volunteers: 'No volunteers',
};

export const browserHistory = createBrowserHistory();

export const errorNames = {
  dateRequired: 'Date required!',
  goalsRequired: 'Goals required!',
  imageRequired: 'Image required!',
  emailRequired: 'Email required!',
  addressRequired: 'Address required!',
  addressValidate: 'Address should be selected from the list',
  detailsRequired: 'Details required!',
  descriptionRequired: 'Description required!',
  endTimeRequired: 'End time required!',
  endTimeValidate: 'End time should not be less or equal than start time and should not be in the past',
  invalidPhone: 'Invalid phone number!',
  passwordRequired: 'Password required!',
  invalidEmail: 'Invalid email address!',
  categoryRequired: 'Category required!',
  qualificationRequired: 'Field is empty!',
  startTimeRequired: 'Start time required!',
  startTimeValidate: 'Start time should not be more or equal than end time and should not be in the past',
  invalidConfirm: 'Password should be same!',
  categoriesRequired: 'Categories required!',
  nameRequired: 'Organisation name required!',
  codeRequired: 'Verification code required!',
  contactNameRequired: 'Contact name required!',
  confirmRequired: 'Confirm password required!',
  opportunityNameRequired: 'Opportunity name required!',
  invalidPassword: 'Password needs uppercase and digit',
  invalidPasswordLetter: 'Password needs uppercase letters',
  invalidPasswordLowercase: 'Password needs lowercase letters',
  invalidPasswordDigit: 'Password needs digit',
  categoriesLength: 'Only 3 categories can be selected!',
  volunteersAmountRequired: 'Volunteers amount required!',
  addressLength: 'Address is allowed 200 characters long!',
  websiteLength: 'Website is allowed 100 characters long!',
  codePattern: 'Verification code should be 6 digits long',
  qualificationLength: 'Field is allowed 101 characters long',
  cancellationPolicyRequired: 'Cancellation policy required!',
  addressMaxLength: 'Address is allowed 1000 characters long!',
  volunteersAmountLength: 'Volunteers amount can\'t exceed 1000!',
  passwordLength: 'Password should be at least 8 characters long',
  contactNameLength: 'Contact name is allowed 100 characters long!',
  nameLength: 'Organisation name is allowed 100 characters long!',
  descriptionLength: 'Description is allowed 3000 characters long!',
  opportunityNameLength: 'Opportunity name is allowed 100 characters long!',
  cancellationPolicyLength: 'Cancellation Policy is allowed 3000 characters long!',
};

export const confirmRegExp = (value: string) => new RegExp(`^${value}$`);

export const errorRegExp = {
  phone: /\+?\d{1,3}[- .]?\d{2,3}[- .]?\d{2,4}/,
  password: /^(?=.*[A-Z])(?=.*\d)(?=.*[a-z]).+$/,
  email: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
  code: /^[0-9][0-9][0-9][0-9][0-9][0-9]$/,
};

export const SustainableDevelopmentGoal = {
  NO_POVERTY: 'No Poverty',
  ZERO_HUNGER: 'Zero Hunger',
  GOOD_HEALTH_AND_WELLBEING: 'Good Health And Wellbeing',
  QUALITY_EDUCATION: 'Quality Education',
  GENDER_EQUALITY: 'Gender Equality',
  CLEAN_WATER_AND_SANITATION: 'Clean Water And Sanitation',
  AFFORDABLE_AND_CLEAN_ENERGY: 'Affordable And Clean Energy',
  SUSTAINABLE_CITIES_AND_COMMUNITIES: 'Sustainable Cities And Communities',
  CLIMATE_ACTION: 'Climate Action',
  LIFE_BELOW_WATER: 'Life Below Water',
  LIFE_ON_LAND: 'Life on Land',
  DECENT_WORK_AND_ECONOMIC_GROWTH: 'Decent Work And Economic Growth',
  INDUSTRY_INNOVATION_AND_INFRASTRUCTURE: 'Industry, Innovation And Infrastructure',
  REDUCED_INEQUALITIES: 'Reduced Inequalities',
  RESPONSIBLE_CONSUMPTION_AND_PRODUCTION: 'Responsible Consumption And Production',
  PEACE_JUSTICE_AND_STRONG_INSTITUTIONS: 'Peace Justice And Strong Institutions',
  PARTNERSHIPS: 'Partnerships',
};

export const opportunityCategories = {
  HOMELESS: 'Homeless',
  ENVIRONMENT: 'Environment',
  ADDICTION: 'Addiction',
  ARTS_AND_CULTURE: 'Arts and culture',
  MENTAL_HEALTH: 'Mental health',
  SPORT: 'Sport',
  DISABILITY: 'Disability',
  SENIORS: 'Seniors',
  EDUCATION: 'Education',
  DOMESTIC_VIOLENCE: 'Domestic violence',
  COMMUNITY: 'Community',
  EMERGENCY_RESPONSE: 'Emergency response',
  SUSTAINABILITY: 'Sustainability',
  ANIMALS: 'Animals',
  HUMAN_RIGHTS: 'Human rights',
  FIRST_NATIONS: 'First nations',
};

export const invertedOpportunityCategories = invert(opportunityCategories);

export const cancellationPolicy = 'Our organisations are counting on you. Most of our volunteers don’t cancel however, should you need to, you can do so through the app and we ask that you give us 12 hours notice so our organisations can find a volunteer off our waitlist or elsewhere';
